export default {
  props: ['data'],
  template: `<div><div id="js-content" v-html="content"></div>
               <div id="js-video-player" class="video-player" style="display: none;"></div>
               <div id="js-modalIframeWrapper" class="embed-responsive-item" style="display: none;"></div></div>`,
  data() {
    return {
      content: '',
      html5Player: null
    };
  },
  watch: {
    'data': {
      handler(newData, oldData) {
        this.render();
      }
    }
  },
  methods: {
    render() {
      let self = this;
      let url;
      if (this.data.file && this.data.file.file) {
        url = this.data.file.file.url;
      } else {
        url = this.data.file.url || this.data.url;
      }
      if (this.data.file.gallery && this.data.file.gallery.url) {
        url = this.data.file.gallery.url;
      }

      //Image files
      if (this.data.meta.type === 'image' || (this.data.attachment && this.data.attachment.meta.type === 'image')) {
        this.content = `<img class="img-preview" src="${url}" alt="${this.data.name}"/>`;
      }

      //Video files
      else if (this.data.meta.type === 'video' || (this.data.attachment && this.data.attachment.meta.type === 'video')) {
        if (this.html5Player) {
          this.html5Player.pause();
          this.html5Player.hide();
        }
        let mediaUrls = {
          h264_360_url: this.data.file.url,
          h264_720_url: ''
        };
        let $player = $('#js-video-player', this.$el);
        $player.show();
        this.html5Player = new Kadenze.VideoPlayer($player, mediaUrls, 'vjs-student-skin');
        this.html5Player.show().play(false);
      }

      //Audio files
      else if (this.data.meta.type === 'audio' || (this.data.attachment && this.data.attachment.meta.type === 'audio')) {
        let mediaObj = {
          id: this.data.id,
          m4a_url: this.data.file.url,
          name: this.data.name,
          user_name: this.data.user_name
        }
        if (!Kadenze.AudioPlayer.initialized()) {
          Kadenze.AudioPlayer.init(function() {
            Kadenze.AudioPlayer.play( mediaObj );
          });
        }
        else {
          Kadenze.AudioPlayer.play( mediaObj );
        }
      }

      //Youtube/Vimeo Links
      else if (this.data.meta.type === 'url') {
        if (this.data.playableLink) {
          let $wrapper = $('#js-modalIframeWrapper', this.$el);
          $wrapper.show();

          let player = new Kadenze.IframeMediaPlayer($wrapper, url);
          player.show();
        }
      }

      //Embedded Text Content
      else if (this.data.meta.type === 'text' && !_.isEmpty(this.data.text_data)) {
        this.content = `<blockquote>${this.data.text_data}</blockquote>`;
      }

      //PDF Files
      else if (this.data.meta.type === 'pdf' || (this.data.attachment && this.data.attachment.meta.type === 'pdf')) {
        this.content = `<iframe width='100%' frameborder='0' height='500px' src='${url}'></iframe>`;
      }

      //All other types
      else {
        //Code/text files
        this.content = 'Loading...';
        let fileUrl = this.data.file.file ? this.data.file.file.url : this.data.file.url;

        let request = new Kadenze.AjaxRequest({
          url: fileUrl,
          type: 'GET',
          dataAsJSON: false,
          contentType: 'text/plain',
          dataType: 'text'
        });

        request.fail(function (xhr, responseText, textStatus) {
          this.content = 'Error Loading File';
          new Kadenze.Notice.error({title: 'Error Loading File', message: Kadenze.I18n.t('notice.unexpected_error')});
        });

        request.done(function (data) {
          if (self.data.meta.type === 'code') {
            self.content = `<pre class='language-${self.data.meta.h_lang}'><code>${data}</code></pre>`;
            if (self.data.meta.h_lang) {
              Prism.highlightElement(this.$el);
            }
          } else {
            self.content = `<pre>${data}</pre>`;
          }
        });
      }
    }
  },
  mounted() {
    this.render();
  },
};

